import { parseMinutesInput } from './parseMinutesInput';

export const isMinutesRangeInvalid = (fromValue: string, toValue: string): boolean => {
  const fromMinutes = parseMinutesInput(fromValue);
  const toMinutes = parseMinutesInput(toValue);

  if (fromMinutes === undefined || toMinutes === undefined) {
    return false;
  }

  return fromMinutes > toMinutes;
};
